import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$http = Axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
Date.prototype.formatMMDDYYYYHHMM = function(){
  return `${this.getMonth() + 1}/${this.getDate()}/${this.getFullYear()} ${this.getHours()}:${this.getMinutes()}`

}

Date.prototype.timer = function(now){
  let distance = now - this.getTime();
  let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  if(hours< 10) hours = "0"+hours;
  let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  if(minutes< 10) minutes = "0"+minutes;
  let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  if(seconds< 10) seconds = "0"+seconds;
  if(days) return `${days} Day(s) ${hours}:${minutes}:${seconds}`;
  else return `${hours}:${minutes}:${seconds}`;

}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
